import React from "react";
import Navbar from "../components/NavLite";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import BgImage from "../assets/newimages/newimage7.jpg";
import WaitlistImg from "../assets/Services/Waitlist App Template.png";
import BookingImg from "../assets/Services/Booking App Template.png";
import NourivImg from "../assets/Services/NourivPlatform.png";

function WaitlistApp() {
  return (
    <div className="bg-white text-gray-900 font-inter">
<Helmet>
  <title>Waitlist Landing Page App for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Build your email list before launch with Woaom Web Design’s Waitlist Landing Page App. A fast, branded, mobile-first template built with React, Tailwind, and Firebase — trusted by women entrepreneurs in Dallas, Houston, Austin, Atlanta, New York City, and more."
  />
  <meta
    name="keywords"
    content="Waitlist landing page Dallas TX, Houston TX waitlist app template, Austin TX email capture website, Atlanta GA waitlist website design, New York City waitlist landing page app, Washington DC prelaunch funnel template, Philadelphia PA waitlist page for women entrepreneurs, Memphis TN waitlist website app, Baton Rouge LA email list builder, Shreveport LA waitlist landing page design, New Orleans prelaunch website template, Macon GA waitlist page template, Augusta GA waitlist app for coaches, Baltimore waitlist funnel app, custom waitlist landing page Dallas women entrepreneurs, mobile-first waitlist site Houston TX, branded waitlist app Austin TX, professional waitlist landing page Atlanta GA, scalable waitlist app New York City founders, feminine waitlist landing page Washington DC, prelaunch waitlist website Philadelphia PA, email capture template Memphis TN, startup waitlist funnel Baton Rouge LA, Shreveport LA prelaunch waitlist site, modern waitlist template New Orleans, easy-to-edit waitlist app Macon GA, creative waitlist website Augusta GA, founder-focused waitlist landing page Baltimore MD, high-converting waitlist site Dallas TX, React Firebase waitlist app template Houston TX"
  />
</Helmet>


      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center bg-no-repeat py-10 px-4 sm:px-6 lg:px-8 text-center shadow-lg"
        style={{ backgroundImage: `url(${BgImage})` }}
      >
        <Navbar />
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Ready to Build Buzz Before You Launch?
          </h1>
          <p className="text-xl sm:text-2xl text-white opacity-90 mb-8 max-w-2xl mx-auto">
            The Waitlist App Template helps you grow your list, validate demand,
            and build excitement — fast.
          </p>
          <p className="text-md sm:text-lg text-white opacity-80 mb-10 max-w-3xl mx-auto">
            Built with React, Tailwind, and Firebase — this app gives you a
            stylish landing page, opt-in form, countdown timer, and mobile-first
            design to drive conversions pre-launch.
          </p>
          <a
            href="https://serenity-studio-template.web.app/"
            className="inline-flex items-center text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black"
          >
            View Demo →
          </a>
        </div>
      </section>

      {/* Product Summary */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={WaitlistImg}
              alt="Waitlist App Template Preview"
              className="shadow-lg rounded-lg"
            />
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              Waitlist Landing Page App
            </h2>
            <p className="text-gray-700 mb-4">
              Perfect for digital product creators, coaches, and service
              providers launching a course, membership, or new offer.
            </p>
            <p className="text-lg font-bold text-[#2E2D2B] mb-6">$199.99</p>

            <a
              href="https://buy.stripe.com/4gMcN67PfdMv6zj1TH4sE04" // Replace with your real Stripe URL
              className="inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              Buy This App →
            </a>
            <p className="text-sm text-gray-500 mt-4">
              Includes code + setup guide + email integration tips
            </p>
          </div>
        </div>
      </section>

      {/* Feature List */}
      <section className="py-12 px-6 bg-gray-50">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl font-semibold mb-6">
            TAKE A PEEK inside the Waitlist App
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-left text-gray-700 text-sm">
            <ul className="space-y-2 list-disc list-inside">
              <li>Hero section with opt-in</li>
              <li>Countdown timer</li>
              <li>Mobile-first responsive layout</li>
              <li>EmailJS or Flodesk form integration</li>
            </ul>
            <ul className="space-y-2 list-disc list-inside">
              <li>Testimonials or social proof section</li>
              <li>Custom brand colors + fonts</li>
              <li>Hosted on Firebase</li>
              <li>Easy to edit + launch</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Longform Description */}
      <section className="py-12 px-6 bg-white">
        <div className="max-w-4xl mx-auto prose prose-lg prose-gray">
          <p>
            The Waitlist App Template gives you a high-converting launch page
            you can actually be proud of. Unlike Canva or Wix pages that slow
            down or fall short, this one is lightweight, modern, and brandable.
          </p>
          <p>
            Connect your Flodesk or EmailJS opt-in form, edit your headline and
            countdown timer, and you’re ready to start growing your list and
            collecting leads — before your offer goes live.
          </p>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-12 px-6 bg-gray-100">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl font-semibold mb-4">You may also like…</h2>
          <div className="grid sm:grid-cols-3 gap-6">
            <a href="/booking">
              <div className="bg-white border text-center rounded-lg shadow-sm">
                <img src={BookingImg} alt="Booking App" className="mb-4" />
                <h3 className="font-semibold">Booking App Template</h3>
                <p className="text-[#2E2D2B] font-medium">$199.00</p>
              </div>
            </a>
            <a href="/nouriv">
              <div className="bg-white border text-center rounded-lg shadow-sm">
                <img src={NourivImg} alt="Nouriv Dashboard" className="mb-4" />
                <h3 className="font-semibold">Nouriv Coaching Dashboard</h3>
                <p className="text-[#2E2D2B] font-medium">$199.99</p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-[#F8F8F8] px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl font-semibold text-center mb-10">
            How It Works
          </h2>
          <ol className="space-y-6 text-gray-700 text-sm">
            <li>
              <strong>Step 1:</strong> Purchase the template + access the code
            </li>
            <li>
              <strong>Step 2:</strong> Customize your headline, branding, and form
            </li>
            <li>
              <strong>Step 3:</strong> Connect Flodesk or EmailJS
            </li>
            <li>
              <strong>Step 4:</strong> Launch with Firebase in minutes
            </li>
            <li>
              <strong>Step 5:</strong> Share your link and grow your list before you launch
            </li>
          </ol>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-semibold text-center mb-8">
            Frequently Asked Questions
          </h2>
          <div className="border-b py-4">
            <h3 className="text-lg font-medium">Does it work with Flodesk?</h3>
            <p className="text-sm mt-2 text-gray-600">
              Yes! You can embed any Flodesk form using the universal script or
              use EmailJS for full control.
            </p>
          </div>
          <div className="border-b py-4">
            <h3 className="text-lg font-medium">
              Can I use this to validate my offer?
            </h3>
            <p className="text-sm mt-2 text-gray-600">
              Absolutely. Many customers use the waitlist to gauge interest and
              pre-sell new programs or digital products.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        id="get-app"
        className="py-16 px-4 sm:px-6 lg:px-8 text-center bg-gray-50 rounded-b-3xl shadow-lg"
      >
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            Grow Your List Before You Launch
          </h2>
          <p className="text-lg text-gray-700 mb-10">
            Get the Waitlist App Template and start building excitement + email
            leads today.
          </p>
          <a
            href="https://buy.stripe.com/test_f5g6h7i8j9a1b2c3d4"
            className="inline-flex items-center text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black"
            target="_blank"
            rel="noopener noreferrer"
          >
            Buy This App →
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default WaitlistApp;
